import React, { useState } from "react";
import { api, formatApiError } from "@/lib/http";
import { Button } from "@/components/ui/button";
import { Sparkles, Check, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

// "Tidy with AI" for the client notes box. Suggestion is previewed; nothing changes until the user accepts.
export const NotesRewrite = ({ clientId, value, onApply }) => {
  const [busy, setBusy] = useState("");
  const [suggest, setSuggest] = useState(null);
  const run = async (style) => {
    if (!(value || "").trim()) { toast.message("Write a few notes first — then I can tidy them."); return; }
    setBusy(style);
    try {
      const { data } = await api.post(`/clients/${clientId}/notes/rewrite`, { text: value, style });
      setSuggest(data.text);
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  return (
    <div className="space-y-2" data-testid="notes-ai">
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="text-[11px] text-muted-foreground inline-flex items-center gap-1"><Sparkles className="h-3 w-3 text-primary" />Rewrite with AI:</span>
        {[["tidy", "Tidy up"], ["shorter", "Make shorter"], ["clinical", "Clinical tone"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => run(k)} disabled={!!busy} className="text-[11px] rounded-full border px-2.5 py-0.5 hover:bg-primary/10 hover:border-primary/40 disabled:opacity-50 transition-colors inline-flex items-center gap-1" data-testid={`notes-ai-${k}`}>
            {busy === k && <Loader2 className="h-3 w-3 animate-spin" />}{l}
          </button>
        ))}
      </div>
      {suggest != null && (
        <div className="rounded-lg border border-primary/30 bg-primary/5 p-3 space-y-2" data-testid="notes-ai-suggestion">
          <div className="text-[11px] font-medium text-primary">Suggested rewrite — review before applying</div>
          <textarea value={suggest} onChange={(e) => setSuggest(e.target.value)} rows={Math.min(10, Math.max(3, suggest.split("\n").length + 1))} className="w-full rounded-md border border-input bg-background p-2 text-sm" data-testid="notes-ai-text" />
          <div className="flex gap-2 justify-end">
            <Button type="button" variant="ghost" size="sm" className="rounded-lg" onClick={() => setSuggest(null)} data-testid="notes-ai-discard"><X className="h-3.5 w-3.5 mr-1" />Discard</Button>
            <Button type="button" size="sm" className="rounded-lg" onClick={() => { onApply(suggest); setSuggest(null); toast.success("Notes replaced — hit Save to keep them"); }} data-testid="notes-ai-apply"><Check className="h-3.5 w-3.5 mr-1" />Use this</Button>
          </div>
        </div>
      )}
    </div>
  );
};
